function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:none;stroke:#24365c;stroke-width:20;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;stroke:#24365c;stroke-width:20;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M107.7,11.1c6.3,0,218.2,0,228.5,0s11.8,5.4,11.8,9.2c0,3.8,0,21,0,32.2s-4.9,12.1-9.9,12.1 c-2.9,0-76.6,0-139.9,0c-46.4,0-87.1,0-90.5,0c-8,0-12.1-5.2-12.1-14.4s0-19.1,0-27.8S101.4,11.1,107.7,11.1z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M11.2,339.8c0-5.3,0-185.2,0-194c0-8.8,5.4-10,9.2-10c3.8,0,21,0,32.2,0s12.1,4.2,12.1,8.4c0,2.4,0,65,0,118.8 c0,39.4,0,74,0,76.8c0,6.8-5.2,10.3-14.4,10.3s-19.1,0-27.8,0S11.2,345.1,11.2,339.8z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M379.9,339.8c0-5.3,0-185.2,0-194c0-8.8,5.4-10,9.2-10c3.8,0,21,0,32.2,0s12.1,4.2,12.1,8.4c0,2.4,0,65,0,118.8 c0,39.4,0,74,0,76.8c0,6.8-5.2,10.3-14.4,10.3c-9.1,0-19.1,0-27.8,0C382.4,350.1,379.9,345.1,379.9,339.8z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M63.2,171.5h72.7c0,0,27.7-44.4,86.5-44.4s86.3,44.8,86.3,44.8h69.6"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M378.2,314.3h-72.7c0,0-27.7,44.4-86.5,44.4s-86.3-44.8-86.3-44.8H63.2"
});

var _ref8 = /*#__PURE__*/React.createElement("line", {
  className: "st1",
  x1: 198.2,
  y1: 64.5,
  x2: 198.2,
  y2: 125.9
});

var _ref9 = /*#__PURE__*/React.createElement("line", {
  className: "st1",
  x1: 246.3,
  y1: 64,
  x2: 246.3,
  y2: 127.6
});

const SvgPipeToShipBlue = (_ref) => {
  let svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 444.9 369.4",
    style: {
      enableBackground: "new 0 0 444.9 369.4"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPipeToShipBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pipe-to-ship-blue.9974ba86.svg";
export { ForwardRef as ReactComponent };